import sanitizeHtml from 'sanitize-html'

import { proxy } from 'core/classes/helpers/UrlHelper'

export interface IAttachFileTarget {
  id: number
  formId: number
  field: string
  fileName: string
}

export interface IDeleteFileTarget {
  uid: string
  formId: number
  field: string
}

class FileApi {
  // Does not save any rows in DB, simply upload the file on server and attaches it to existing row.
  public uploadAndAttachOnServer(target: IAttachFileTarget, file: File, accessToken: string) {
    const { id, formId, field, fileName } = target

    const url = proxy(`/form/${formId}/attachments/${id}/${field}/handler`)

    const data = new FormData()
    data.append('Attachment', 'Attachment')
    data.append(field, file, fileName)

    return fetch(sanitizeHtml(url), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'POST',
      body: data,
    })
  }

  // Does not delete any rows in DB, simply deletes the file on server.
  public deleteFromServer(target: IDeleteFileTarget, accessToken: string) {
    const { uid, formId, field } = target
    const url = proxy(`/form/${formId}/attachments/v2/${uid}/${field}/handler`)

    return fetch(sanitizeHtml(url), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'DELETE',
    })
  }
}

export const fileApi = new FileApi()
